module.exports = __webpack_public_path__ + "img/122.3ff5e906.svg";